/**
 * Helpers para lista de ações em passos do chatbot (espelha API chatbotActionParams).
 */

export function toActionValue(tipoAcao, idAcao) {
  return `${Number(tipoAcao) || 0}-${Number(idAcao) || 0}`;
}

export function acoesFromSlot(slot) {
  if (Array.isArray(slot?.acoes) && slot.acoes.length) {
    return slot.acoes.map((a) => ({
      value: toActionValue(a.tipo_acao, a.id_acao),
      tipo_acao: Number(a.tipo_acao) || 0,
      id_acao: Number(a.id_acao) || 0,
      values: a.values || {},
      labels: a.labels || {},
      urlapi: a.urlapi || "",
    }));
  }

  const tipo = Number(slot?.tipo_acao) || 0;
  const id = Number(slot?.id_acao) || 0;
  if (!tipo && !id) return [];

  return [
    {
      value: toActionValue(tipo, id),
      tipo_acao: tipo,
      id_acao: id,
      values: slot?.acao_parametros?.values || {},
      labels: slot?.acao_parametros?.labels || {},
      urlapi: "",
    },
  ];
}

export function acoesToPayload(acoes) {
  return (acoes || [])
    .filter((a) => Number(a.tipo_acao) && Number(a.id_acao))
    .map(({ tipo_acao, id_acao, values, labels, urlapi }) => {
      const item = {
        tipo_acao: Number(tipo_acao),
        id_acao: Number(id_acao),
        values: values || {},
        labels: labels || {},
      };
      if (urlapi && String(urlapi).trim()) item.urlapi = String(urlapi).trim();
      return item;
    });
}

export function legacyFieldsFromAcoes(acoes) {
  const first = acoes?.[0];
  if (!first) return { tipo_acao: 0, id_acao: 0 };
  return {
    tipo_acao: Number(first.tipo_acao) || 0,
    id_acao: Number(first.id_acao) || 0,
  };
}
